/**
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
**/

/* HPX-515 start */

(function ($) {
  $(function () {
    var $main   = $('.variant-grouped-hpx-version');
    var $thumbs = $('.variant-thumbs-hpx-version');
    if (!$main.length || !$thumbs.length) return;

    if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('unslick');
    if ($main.hasClass('slick-initialized'))   $main.slick('unslick');

    $thumbs.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.variant-grouped-hpx-version',
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: false,
      focusOnSelect: true,
      mobileFirst: true,
      vertical: false,
      verticalSwiping: false,
      responsive: [
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
            arrows: true
            }
        }, 
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            arrows: true
          }
        }
      ]
    });

    $thumbs.on('click', '.slick-slide', function (e) {
      var hasAnchor = $(e.target).closest('a').length > 0;
      if (hasAnchor) e.preventDefault();
      var index = $(this).data('slick-index');
      if (typeof index === 'number') {
        $main.slick('slickGoTo', index, true);
      }
    });

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.variant-thumbs-hpx-version',
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: true,
      mobileFirst: true
    });

    $thumbs.slick('slickGoTo', 0, true);
    $main.slick('slickGoTo', 0, true);
    $thumbs.slick('setPosition');
    $main.slick('setPosition');

    var $sliderWrapper = $main.closest('.productView-nav.productView-main-slider');
    var total = $main.find('.slick-slide:not(.slick-cloned)').length;
    if ($sliderWrapper.length) {
      $sliderWrapper.attr('data-media-count', total);
    }
    $main.trigger('afterChange', [ $main, 0 ]);
  });
})(jQuery);

/* HPX-515 start */

/* HPX-35 start */

document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.sections-policies-block');
  if (!el) return;

  let originalTop = el.getBoundingClientRect().top + window.pageYOffset;
  let originalHeight = el.offsetHeight;
  let isFixed = false;

  function setFixed(on) {
    if (on && !isFixed) {
      el.classList.add('is-fixed');
      isFixed = true;
    } else if (!on && isFixed) {
      el.classList.remove('is-fixed');
      isFixed = false;
    }
  }

  function evaluate() {
    const y = window.pageYOffset;
    const naturalTop = originalTop;
    const naturalBottom = originalTop + originalHeight;
    
    // At very top of page → not fixed
      if (y <= 0) {
        setFixed(false);
        return;
      }

    if (window.location.pathname === '/')
    {                     
      // If scrolled past the element → not fixed
      if (y > naturalBottom) {
        setFixed(false);
        return;
      }

      // If viewport top is below the element’s top → fix it
      if (y < naturalTop) {
        setFixed(true);
        return;
      }
    } else {

      const viewportBottom = y + window.innerHeight;                  

      // If scrolled past the element → not fixed
      if (y > naturalBottom) {
        setFixed(false);
        return;
      }

      // If viewport bottom is above the element → fix it
      if (viewportBottom <= naturalTop) {
        setFixed(true);
        return;
      }
    }
    // Otherwise → not fixed
    setFixed(false);
  }

  // Recompute geometry on resize
  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const wasFixed = isFixed;
      if (wasFixed) el.classList.remove('is-fixed');
      originalTop = el.getBoundingClientRect().top + window.pageYOffset;
      originalHeight = el.offsetHeight;
      if (wasFixed) el.classList.add('is-fixed');
      evaluate();
    }, 120);
  }

  window.addEventListener('scroll', evaluate, { passive: true });
  window.addEventListener('resize', onResize);

  // Initial evaluation
  evaluate();
});

/* HPX-35 end */

/* Ticket Number- HPX-167 Start Code */
function updateRecyclingFee() {          
    fetch('/cart?section_id=main-cart') // or recycling-fee if it's a standalone section
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const updatedFee = doc.querySelector('.recycling-collection-fee-amount');          
      const target = document.querySelector('.recycling-collection-fee-amount');      
      if (updatedFee && target) {
        target.innerHTML = updatedFee.innerHTML;
      }
    });
}
/* Ticket Number- HPX-167 End Code */

/* HPX-348 */
  const maxDuration = 2 * 60 * 1000; // 2 minutes in milliseconds
  const intervalTime = 500; // check every 500ms
  let elapsedTime = 0;

  const checkFlyout = setInterval(() => {
    elapsedTime += intervalTime;

    const flyout = document.querySelector('[data-testid="FLYOUT"]');
    if (flyout) {      
      const firstInput = flyout.querySelector('input');
      const firstname = firstInput.id;
      const inputField = document.getElementById(firstname);      
      if (inputField) {
        inputField.focus(); 
        clearInterval(checkFlyout); // Stop checking once done
      }
    }
    // Stop checking after 2 minutes
    if (elapsedTime >= maxDuration) {
      clearInterval(checkFlyout);
    }
  }, intervalTime);
/* HPX-348 */

/* HPX-260 */
const storelist = [
              {
                  storeCode: "CA",
                  storeName: "Canada",
                  storeUrl: "https://ca.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "EN",
                  supportedCurrencies: "CAD",
                  supportedStores: "CA"
              },             
              {
                  storeCode: "US",
                  storeName: "United States",
                  storeUrl: "https://hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "US"
              }, 
              {
                  storeCode: "AU",
                  storeName: "Australia",
                  storeUrl: "https://au.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "AUD",
                  supportedStores: "AU"
              }, 
              {
                  storeCode: "ROW",
                  storeName: "Global",
                  storeUrl: "https://row.hyperx.com/",
                  supportedLanguages: "EN, AR, DE, ES, ES419, FR, IT, ID, PL, pt-BR, RU, VI, TR, TH, KO, zh-CN, zh-TW, JA",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "AF,AX,AL,DZ,AS,AD,AO,AI,AQ,AG,AR,AM,AW,AT,AZ,BS,BH,BD,BB,BE,BZ,BJ,BM,BT,BO,BQ,BA,BW,BR,IO,BN,BG,BF,BI,KH,CM,CV,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CK,CR,CI,HR,CW,CY,CZ,CD,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,GH,GI,GR,GL,GD,GP,GU,GT,GN,GW,GY,HT,VA,HN,HK,HU,IS,IN,ID,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KR,XK,KW,KG,LA,LV,LB,LS,LR,LI,LT,LU,MO,MK,MG,MW,MY,MV,ML,MT,MH,MQ,MR,MU,YT,MX,FM,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MP,NO,OM,PK,PW,PS,PA,PG,PY,PE,PH,PN,PL,PT,PR,QA,RE,RO,RW,BL,SH,KN,LC,MF,PM,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,ZA,GS,SS,ES,LK,SD,SR,SJ,SZ,SE,CH,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TM,TC,TV,UG,UA,AE,UM,UY,UZ,VU,VN,VG,VI,WF,EH,ZM,ZW"
              }, 
              {
                  storeCode: "GB",
                  storeName: "United Kingdom",
                  storeUrl: "https://uk.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "GBP",
                  supportedStores: "GB"
              }, 
              {
                  storeCode: "DE",
                  storeName: "Germany",
                  storeUrl: "https://de.hyperx.com/",
                  supportedLanguages: "DE, EN",
                  defaultLanguage: "DE",
                  supportedCurrencies: "EUR",
                  supportedStores: "DE"
              },
              {
                  storeCode: "FR",
                  storeName: "France",
                  storeUrl: "https://fr.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "FR",
                  supportedCurrencies: "EUR",
                  supportedStores: "FR"
              },
              {
                  storeCode: "Sandbox",
                  storeName: "Sandbox",
                  storeUrl: "https://hyperx-gg.myshopify.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN, DE, FR, IT, ID",
                  supportedCurrencies: "USD",
                  supportedStores: "Sandbox"
              }
          ];

          /**
           * Handles the change event when a user selects a different country from the dropdown.
           *
           * @param {HTMLSelectElement} selectElement - The country <select> element that triggered the change.
           */
          function handleCountryChange(selectElement) {
            // Get the selected country code from the dropdown
            const selectedCountry = selectElement.value;

            // Call a custom function to update the URL or perform actions based on the selected country
            setcustomCountryURL(selectedCountry);
          }
              

          /**
           * Retrieves the store URL for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The corresponding store URL (e.g., "https://ca.hyperx.com/").
           */
          function getsupportedstoreurl(storecode) {
            // Find the index of the store object that matches the given store code
            let storeindex = storelist.findIndex((item) => item.storeCode === storecode);

            // Access the storeUrl property from the matched store object
            let storeUrl = storelist[storeindex]['storeUrl'];

            // Return the store URL
            return storeUrl;
          }

          
          /**
           * Finds the storeCode that supports a given country code.
           *
           * @param {string} fetchcountrycode - The country code to look for (e.g., "CA", "US").
           * @returns {string} - The storeCode that supports the given country code.
           */
          function getsupportedStores(fetchcountrycode) {
            var i = 0;
            var supportedstorecode = ''; // Initialize the result variable

            // Loop through each store in the storelist
            while (i < storelist.length) {
              // Get the supportedStores string for the current store
              var supportedStores = storelist[i].supportedStores;

              // Split the string into an array of individual country codes
              var supportedStoressplit = supportedStores.split(",");

              // Loop through each supported country code
              for (var g in supportedStoressplit) {
                // Check if the current country code matches the one we're looking for
                if (fetchcountrycode == supportedStoressplit[g]) {
                  // If matched, assign the storeCode of the current store
                  supportedstorecode = storelist[i]['storeCode'];
                }
              }

              // Move to the next store in the list
              i++;
            }

            // Return the matched storeCode (or empty string if not found)
            return supportedstorecode;
          }


          /**
           * Retrieves the supported languages for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - A comma-separated string of supported language codes (e.g., "EN, FR").
           */
          function getsupportedLanguages(storecode) {
            // Find the index of the store object that matches the given store code
            let storeindex = storelist.findIndex((item) => item.storeCode === storecode);

            // Access the supportedLanguages property from the matched store object
            let supportedLanguages = storelist[storeindex]['supportedLanguages'];

            // Return the supported languages for the store
            return supportedLanguages;
          }

          /**
           * Retrieves the default language for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The default language code for the specified store (e.g., "EN").
           */
          function getdefaultLanguage(storecode) {
            // Find the index of the store object in the storelist that matches the given store code
            let storeindex = storelist.findIndex((item) => item.storeCode === storecode);

            // Access the defaultLanguage property from the matched store object
            let defaultLanguage = storelist[storeindex]['defaultLanguage'];

            // Return the default language code
            return defaultLanguage;
          }


          /**
           * Constructs and redirects to a localized store URL based on the selected country code.
           *
           * @param {string} countryCode - The selected country code (e.g., "CA", "US").
           */
          function setcustomCountryURL(countryCode) {            

            // Get the storeCode that supports the selected country
              const storeCode = getsupportedStores(countryCode);

              // Get the base store URL for that storeCode
              const storeurl = getsupportedstoreurl(storeCode);

              // Get the store's default language
              const defaultlanguage = getdefaultLanguage(storeCode);

              // Get the current language code from the <html> tag (e.g., "en-US", "fr-FR")
              const storeLang = document.documentElement.getAttribute("lang");

              // Extract the language prefix (e.g., "en" from "en-US")
              const currentLanguageCode = storeLang.substring(0, 2);

              // Check if the current language code maps to a supported store
              const supportcountryexists = getsupportedStores(currentLanguageCode.toUpperCase());

              // Get supported languages for the target store
              const supportLanguage = getsupportedLanguages(storeCode);

              // Check if the current language is supported by the target store
              const supportlanguageexists = supportLanguage.includes(currentLanguageCode.toUpperCase());

              // Get the full current URL
              const fullUrl = window.location.href;

              // Parse the URL into components
              const urlObj = new URL(fullUrl);

              // Extract the path and query string
              const extractedUrl = urlObj.pathname + urlObj.search;

              // Build the new base URL by appending the path to the store URL
              const cleanedUrl = storeurl + (extractedUrl.startsWith("/") ? extractedUrl.substring(1) : extractedUrl);

              // Create a new query string object and remove any existing `loc` parameter
              const params = new URLSearchParams(urlObj.search);
              params.delete("loc");

              // Add the new `loc` parameter with the selected country code
              params.append("loc", countryCode);

              // Start with a base complete URL
              let completeUrl = cleanedUrl.split("?")[0] + "?" + params.toString();

              // If the current language is supported by the target store and differs from the default,
              // inject the language code into the URL path
              if (supportlanguageexists && currentLanguageCode.toUpperCase() !== defaultlanguage) {
                const baseUrl = storeurl.endsWith("/") ? storeurl.slice(0, -1) : storeurl;
                const pathAndQuery = cleanedUrl.replace(storeurl, "");
                completeUrl = `${baseUrl}/${currentLanguageCode.toLowerCase()}/${pathAndQuery.split("?")[0]}?${params.toString()}`;
              }

              // If the store's default language matches the current language code,
              // or if the language is unsupported, remove the language code from the URL path
              if (
                defaultlanguage === currentLanguageCode.toUpperCase() ||
                supportlanguageexists === false ||
                (supportcountryexists !== '' && countryCode === currentLanguageCode.toUpperCase())
              ) {
                completeUrl = completeUrl
                  .replace(`/${currentLanguageCode.toLowerCase()}?`, "?")
                  .replace(`/${currentLanguageCode.toLowerCase()}/`, "/");
              }
              
            // Redirect the user to the newly constructed URL
            window.location.href = completeUrl;
          }        

        document.querySelectorAll('.language-selector').forEach(function(selector) {
            selector.addEventListener('change', function () {

              const selectedLang = this.value.toLowerCase();
              const currentUrl = window.location.href;
              const url = new URL(currentUrl);
              const pathSegments = url.pathname.split('/').filter(Boolean);

              // Replace or insert language code
              if (pathSegments.length > 0 && pathSegments[0].length === 2) {
                  pathSegments[0] = selectedLang;
              } else {
                  pathSegments.unshift(selectedLang);
              }
              // If selected language is default, remove language code from path
              if (selectedLang === defaultLanguage) {
                  pathSegments.shift(); // remove language code
              }
              const newPath = '/' + pathSegments.join('/') + '/';
              window.location.href = (url.origin + newPath + url.search).replace(/\/+$/, "") + "/";
            })
        });

        
         /**
          * Restores the selected country in the dropdown when the page is loaded from the browser's cache,
          * such as after using the back or forward button.
          */
          window.addEventListener('pageshow', function () {
              // Get the country <select> element by its ID
              const countrySelector = document.getElementById('country-selector');

              // Loop through each option in the dropdown
              for (let i = 0; i < countrySelector.options.length; i++) {
                  // Compare each option's value (lowercased) with the defaultCountry
                  if (countrySelector.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set the dropdown's selected index to this option
                      countrySelector.selectedIndex = i;
                      break; // Exit the loop once a match is found
                  }
              }
          });


          // Get the <select> element for country selection by its ID
          const countrySelector = document.getElementById('country-selector');
          
          // Loop through each option in the dropdown
          for (let i = 0; i < countrySelector.options.length; i++) {
              // Check if the current option's value matches the default country (case-insensitive)
              if (countrySelector.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set this option as the selected one
                  countrySelector.selectedIndex = i;
                  break; // Exit the loop once the match is found
              }
          }


          /**
          * Restores the selected country in the dropdown when the page is loaded from the browser's cache,
          * such as after using the back or forward button.
          */
          window.addEventListener('pageshow', function () {
              // Get the country <select> element by its ID
              const countrySelectorfooter = document.getElementById('country-selectorfooter');

              // Loop through each option in the dropdown
              for (let i = 0; i < countrySelectorfooter.options.length; i++) {
                  // Compare each option's value (lowercased) with the defaultCountry
                  if (countrySelectorfooter.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set the dropdown's selected index to this option
                      countrySelectorfooter.selectedIndex = i;
                      break; // Exit the loop once a match is found
                  }
              }
          });


          // Get the <select> element for country selection by its ID
          const countrySelectorfooter = document.getElementById('country-selectorfooter');
          
          // Loop through each option in the dropdown
          for (let i = 0; i < countrySelectorfooter.options.length; i++) {
              // Check if the current option's value matches the default country (case-insensitive)
              if (countrySelectorfooter.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set this option as the selected one
                  countrySelectorfooter.selectedIndex = i;
                  break; // Exit the loop once the match is found
              }
          }

           /**
          * Restores the selected country in the dropdown when the page is loaded from the browser's cache,
          * such as after using the back or forward button.
          */
          window.addEventListener('pageshow', function () {
              // Get the country <select> element by its ID
              const countrySelectormobile = document.getElementById('country-selectormobile');

              // Loop through each option in the dropdown
              for (let i = 0; i < countrySelectormobile.options.length; i++) {
                  // Compare each option's value (lowercased) with the defaultCountry
                  if (countrySelectormobile.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set the dropdown's selected index to this option
                      countrySelectormobile.selectedIndex = i;
                      break; // Exit the loop once a match is found
                  }
              }
          });


          // Get the <select> element for country selection by its ID
          const countrySelectormobile = document.getElementById('country-selectormobile');
          
          // Loop through each option in the dropdown
          for (let i = 0; i < countrySelectormobile.options.length; i++) {
              // Check if the current option's value matches the default country (case-insensitive)
              if (countrySelectormobile.options[i].value.toLowerCase() === defaultCountry) {
                  // If matched, set this option as the selected one
                  countrySelectormobile.selectedIndex = i;
                  break; // Exit the loop once the match is found
              }
          }

         
/* HPX-260 */  

